var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#settings_svg__a)",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12a8.049 8.049 0 0 0-.188-1.713l2.714-2.055-2-3.464-3.143 1.326a7.986 7.986 0 0 0-2.96-1.719L14 1h-4l-.422 3.375c-1.1.352-2.11.939-2.96 1.719L3.473 4.768l-2 3.464 2.714 2.055a7.9 7.9 0 0 0 0 3.426l-2.714 2.055 2 3.464 3.143-1.326a7.987 7.987 0 0 0 2.961 1.719L10 23h4l.422-3.375a7.986 7.986 0 0 0 2.961-1.719l3.143 1.326 2-3.464-2.714-2.055A8.049 8.049 0 0 0 20 12Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "settings_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgSettings;